import { render } from "./LeadGenerator.vue?vue&type=template&id=4d15bffd&scoped=true"
import script from "./LeadGenerator.vue?vue&type=script&lang=js"
export * from "./LeadGenerator.vue?vue&type=script&lang=js"

import "./LeadGenerator.vue?vue&type=style&index=0&id=4d15bffd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d15bffd"]])

export default __exports__